import { render } from "./dropdown-with-text.html?vue&type=template&id=6d371338&scoped=true&ts=true&external"
import script from "./dropdown-with-text.ts?vue&type=script&lang=ts&external"
export * from "./dropdown-with-text.ts?vue&type=script&lang=ts&external"

import "./dropdown-with-text.scss?vue&type=style&index=0&id=6d371338&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d371338"]])

export default __exports__